import { mapGetters, mapActions } from 'vuex'

import ScrollableList from '@/components/ScrollableList/index'
import LazyImage from '@/components/LazyImage/index'

export default {
  name: 'results',
  components: {
    ScrollableList,
    LazyImage
  },
  data: () => ({
    baseUrl: '',
    pageArr: null
  }),
  computed: {
    ...mapGetters('results', {
      resultsPageResponse: 'RESULTS_PAGE'
    })
  },
  methods: {
    ...mapActions('results', {
      fetchResultsPageAction: 'FETCH_RESULTS_PAGE'
    })
  },
  activated() {
    this.baseUrl = `/admin/track-prediction`
    this.fetchResultsPageAction().then(() => {
      this.pageArr = {
        pages: this.resultsPageResponse.data,
        ongoingRound: this.resultsPageResponse.nearestRound
      }
    })
    this.$store.commit('SET_PAGE_TITLE', 'Track Prediction')
    this.$store.commit('SET_SHOW_LOGO', true)
  },
  deactivated() {
    this.$store.commit('SET_PAGE_TITLE', '')
    this.$store.commit('SET_SHOW_LOGO', false)
  }
}
